<template>
    <div class="paper-info-page">
      <div class="title">
          <div class="title-left">
            <div class="row-1">
              {{ papername }}
            </div>
            <div class="score">
              <span>得分</span> {{user_score || '-'}}/{{paper_score || '-'}}
            </div>
          </div>
          <div class="title-right">
              <el-button
                      type="primary"
                      size="middle"
                      :disabled="is_publish"
                      @click="publish"
                      >
                  发布给学员
              </el-button>
          </div>
      </div>
        <div class="content">
            <div class="content-container">
            <el-tabs type="border-card" @tab-click="tabClick" class="page-tab">
              <el-tab-pane v-for="(item,index) in question_list" :key="index"

              >
                <span slot="label"><img src="../../../static/images/paper_status.png" class="status_image" v-show="item.is_man_made_correct"> {{ item.question_num }}</span>
                <!-- 材料 -->
                <div class="part" v-if="item.question_correct.material_num_type">
                    <div class="item-title">材料</div>
                    <div class="item-content">
                      <span class="blue" @click="viewMetrail(item)">查看材料</span>
                    </div>
                </div>
                <div class="stem">
                    <div class="item-title">题干</div>
                    <div class="item-content" v-if="item.question_correct.stem" v-html="item.question_correct.stem"></div>
                    <div class="item-content" v-else="item.question_correct.question_stem" v-html="item.question_correct.question_stem"></div>
                </div>
                <div class="time-info clearfix">
                    <div class="left time"><span class="item-title">用时:</span> <span class="item-content">{{ item.question_correct.duration }}</span></div>
                    <div class="left score"><span class="item-title">得分:</span> <span class="item-content">{{ item.question_correct.answer_score || '-' }}/{{ (item.has_score_standard ? item.question_correct.question_score :item.question_correct.score) || '-' }}</span></div>
                </div>
                <!-- 学员作答and评分标准 -->
                <div class="part part-flex" v-if="item.has_score_standard">
                  <div class="left">
                    <div class="item-title">学员作答</div>
                    <div>
                      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane label="答题卡作答" name="first"></el-tab-pane>
                        <el-tab-pane label="文字作答" name="second"></el-tab-pane>
                        <el-tab-pane label="图片作答" name="third"></el-tab-pane>
                        <el-tab-pane label="视频作答" name="fourth"></el-tab-pane>
                      </el-tabs>
                    </div>
                    <div class="item-content" ref="box" style="position: relative; margin-right: 15px;">
                      <div class="part-1" ref="first">
                        <div class="part-title">
                          答题卡作答
                        </div>
                        <div class="part-content">
                          <el-upload
                            action="#"
                            :file-list="item.question_answer_sheet_arr"
                            list-type="picture-card"
                            :auto-upload="false">
                              <i slot="default" class="el-icon-plus"></i>
                              <div slot="file" slot-scope="{file}" style="width: 100%; height: 100%;">
                                <img
                                  class="el-upload-list__item-thumbnail"
                                  :src="file.url" alt=""
                                >
                                <span class="el-upload-list__item-actions">
                                  <span
                                    class="el-upload-list__item-preview"
                                    @click="handlePictureCardPreview(file.url)"
                                  >
                                    <i class="el-icon-zoom-in"></i>
                                  </span>
                                  <span
                                    v-if="!is_publish"
                                    class="el-upload-list__item-delete"
                                    @click="handleDownload(file)"
                                  >
                                    <i class="el-icon-download"></i>
                                  </span>
                                </span>
                              </div>
                          </el-upload>
                          <div class="all-words" v-show="!item.question_answer_sheet_arr || !item.question_answer_sheet_arr.length">
                            <div>无</div>
                          </div>
                        </div>
                      </div>
                      <div class="part-1" ref="second">
                        <div class="part-title">
                          文字作答
                        </div>
                        <div class="part-content">
                          <div class="all-words" v-for="(content_standard,content_standard_index) in item.content_standard"  :key="content_standard_index">
                            <div v-html="content_standard.str"></div>
                          </div>
                          <div class="all-words" v-show="!item.content_standard || !item.content_standard.length">
                            <div>无</div>
                          </div>
                        </div>
                      </div>
                      <div class="part-1" ref="third">
                        <div class="part-title">
                          图片作答
                        </div>
                        <div class="part-content">
                          <img :src="img_url" class="image" @click="handlePictureCardPreview(img_url)" v-for="img_url in item.question_correct.question_pic">
                          <div class="all-words" v-show="!item.question_correct.question_pic || !item.question_correct.question_pic.length ">
                            <div>无</div>
                          </div>
                        </div>
                      </div>
                      <div class="part-1" ref="fourth">
                        <div class="part-title">
                          视频作答
                        </div>
                        <div class="part-content">
                          <video-player :id="`video_${item.question_id}`" :url="item.question_correct.user_answer_video || item.question_correct.answer_video" v-if="item.question_correct.user_answer_video || item.question_correct.answer_video"></video-player>
                          <div class="all-words" v-else>
                            <div>无</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <div class="item-title">评分标准</div>
                    <div>
                      <el-tabs v-model="activeName2" type="card" @tab-click="handleClick2">
                        <el-tab-pane label="内容采分点" name="first_1"></el-tab-pane>
                        <el-tab-pane label="结构采分点" name="second_1"></el-tab-pane>
                      </el-tabs>
                    </div>
                    <div class="item-content" ref="box2" style="position: relative;">
                      <div class="part-1" ref="first_1">
                        <div class="part-title">
                          内容采分点
                        </div>
                        <div class="part-content">
                          <div class="answer-content-item" v-for="(content_standard,content_standard_index) in item.content_standard" :key="content_standard_index">
                              <div class="answer-type"><img src="../../../static/images/papertype.png" class="image">{{ content_standard.score_section_name }}</div>
                              <div class="score-point">
                                  <el-card class="box-card" v-for="(content_standard_point,content_standard_point_index) in content_standard.section" :key="content_standard_point_index">
                                      <el-row>
                                          <el-col :span="6">
                                              <span class="font-s">采分点：</span>{{ content_standard_point.max_score }}分
                                          </el-col>
                                          <el-col :span="7">
                                              <span class="font-s">学员得分：</span><span class="student-score">{{ content_standard_point.score }}分</span>
                                          </el-col>
                                          <el-col :span="11" class="correction-score">
                                              <span class="font-s">修正得分：</span>
                                              <span class="student-score">{{ content_standard_point.revise_score }}分</span>
                                          </el-col>
                                      </el-row>
                                      <div class="key-item" v-for=" (content_standard_point_item,index_line) in content_standard_point.keyline " :key="index_line">
                                          <div class="key-line">关键句{{ index_line + 1 }}：<span :class="content_standard_point_item.if_choose==1?'choose':''">{{ content_standard_point_item.keyline }}({{ content_standard_point_item.max_score }}分)</span></div>
                                          <div class="key-word" v-for="(content_standard_point_item_key,key_index) in content_standard_point_item.keyword" :key="key_index">关键词{{ key_index + 1 }}：{{ content_standard_point_item_key }}</div>
                                      </div>
                                  </el-card>
                              </div>
                          </div>
                          <div class="answer-content-item" v-show="!item.content_standard || !item.content_standard.length">无</div>
                        </div>
                      </div>
                      <div class="part-1" ref="second_1">
                        <div class="part-title">
                          结构采分点
                        </div>
                        <div class="part-content">
                          <div v-for="(structure_item,structure_item_index) in item.structure_standard" class="answer-content-item">
                              <div class="answer-type score-point">
                                  <el-row>
                                      <el-col :span="6">
                                          <img src="../../../static/images/papertype.png" class="image">{{ structure_item.score_section_name }}
                                      </el-col>
                                      <el-col :span="7" v-show="item.score_mode==1">
                                          <span class="font-s">学员得分：</span><span :class="structure_item.max_score>structure_item.answer_score?'student-score red':'student-score'">{{ structure_item.answer_score    }}分</span>
                                      </el-col>
                                      <el-col :span="7" v-show="item.score_mode==0">
                                          <span class="font-s">学员扣分：</span><span :class="structure_item.answer_score > 0?'student-score red':'student-score'">{{ structure_item.answer_score    }}分</span>
                                      </el-col>
                                      <el-col :span="11" class="correction-score">
                                          <span class="font-s">{{ item.score_mode == 0?"修正扣分":"修正得分" }}：</span>
                                          <span class="student-score">{{ structure_item.revise_score }}分</span>
                                      </el-col>
                                  </el-row>
                              </div>
                              <div class="score-point">
                                  <el-card class="box-card">
                                      <div class="key-item" v-for="structure_item_section in structure_item.sections">
                                          <div :class="structure_item_section.if_choose==1?'key-line choose':'key-line'">{{ structure_item_section.check_name }}({{ structure_item_section.score }}分)</div>
                                      </div>
                                  </el-card>
                              </div>
                          </div>
                          <div class="answer-content-item" v-show="!item.structure_standard || !item.structure_standard.length">无</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="part" v-else>
                  <div class="item-title">学员作答</div>
                  <div class="item-content">
                    <div class="part-1">
                      <div class="part-title">
                        答题卡作答
                      </div>
                      <div class="part-content">
                        <el-upload
                          action="#"
                          :file-list="item.question_answer_sheet_arr"
                          list-type="picture-card"
                          :auto-upload="false">
                            <i slot="default" class="el-icon-plus"></i>
                            <div slot="file" slot-scope="{file}" style="width: 100%; height: 100%;">
                              <img
                                class="el-upload-list__item-thumbnail"
                                :src="file.url" alt=""
                              >
                              <span class="el-upload-list__item-actions">
                                <span
                                  class="el-upload-list__item-preview"
                                  @click="handlePictureCardPreview(file.url)"
                                >
                                  <i class="el-icon-zoom-in"></i>
                                </span>
                                <span
                                  v-if="!is_publish"
                                  class="el-upload-list__item-delete"
                                  @click="handleDownload(file)"
                                >
                                  <i class="el-icon-download"></i>
                                </span>
                              </span>
                            </div>
                        </el-upload>
                        <div class="all-words" v-show="!item.question_answer_sheet_arr || !item.question_answer_sheet_arr.length">
                          <div>无</div>
                        </div>
                      </div>
                    </div>
                    <div class="part-1">
                      <div class="part-title">
                        文字作答
                      </div>
                      <div class="part-content">
                        <div class="all-words" v-for="(user_answer_content,content_index) in item.question_correct.user_answer"  :key="content_index">
                          <div v-html="user_answer_content.content"></div>
                        </div>
                        <div class="all-words" v-show="!item.question_correct.user_answer || !item.question_correct.user_answer.length ">
                          <div>无</div>
                        </div>
                      </div>
                    </div>
                    <div class="part-1">
                      <div class="part-title">
                        图片作答
                      </div>
                      <div class="part-content">
                        <img :src="img_url" style="width: 22.5%; margin-right: 1%;" class="image" @click="handlePictureCardPreview(img_url)" v-for="img_url in item.question_correct.question_pic">
                        <div class="all-words" v-show="!item.question_correct.question_pic || !item.question_correct.question_pic.length ">
                          <div>无</div>
                        </div>
                      </div>
                    </div>
                    <div class="part-1">
                      <div class="part-title">
                        视频作答
                      </div>
                      <div class="part-content">
                        <video-player :id="`video_${item.question_id}`" :url="item.question_correct.user_answer_video || item.question_correct.answer_video" :config="{ width: '50%'}" v-if="item.question_correct.user_answer_video || item.question_correct.answer_video"></video-player>
                        <div class="all-words">
                          <div>无</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 用户作答完毕 -->
                <div class="user-answer" v-if="item.score_mode > -1">
                  <div class="item-answer clearfix">
                      <div class="item-title left half" style="margin: 10px 0 -15px 0;">作答分析</div>
                  </div>
                    <!-- 总体评价 -->
                    <div class="item-answer clearfix" v-if="item.score_mode==0">
                        <div class="answer-title">总体评价
                            <div v-show="item.question_correct.answer_evaluate" @click="openClose(index,'is_evaluate')">
                                <span class="open-close" v-show="item.is_evaluate">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_evaluate">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                            </div>
                        <div class="des-info" v-show="item.question_correct.answer_evaluate && item.is_evaluate">{{ item.question_correct.answer_evaluate }}</div>
                    </div>
                    <!-- 问题诊断 -->
                    <div class="item-answer clearfix" v-if="item.score_mode==1">
                        <div class="answer-title">问题诊断
                            <div @click="openClose(index,'is_diagnose')">
                                <span class="open-close" v-show="item.is_diagnose">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_diagnose">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                        </div>
                        <div v-show="is_click"></div>
                        <div v-show="item.is_diagnose" class="diagnose_content">
                            <p v-html="item.question_correct.answer_diagnose.header_text"></p>
                            <p  class="diagnose_type_title">缺少的要点为：</p>
                                <div v-show="item.question_correct.answer_diagnose.miss_point.length==0">无</div>
                                <div v-show="item.question_correct.answer_diagnose.miss_point.length!=0" v-for="diagnose_miss_item in item.question_correct.answer_diagnose.miss_point">
                                    <div class="diagnose_type_title">
                                        <span v-html="diagnose_miss_item.user_answer"></span><span v-html='diagnose_miss_item.user_score'></span>
                                    </div>
                                    <p v-show="diagnose_miss_item.material_content" class="diagnose_title">对应材料：</p>
                                    <div v-html="diagnose_miss_item.material_content"   class="diagnose_item_content"></div>
                                    <p v-show="diagnose_miss_item.material_analysis"  class="diagnose_title">要点讲解：</p>
                                    <div v-html="diagnose_miss_item.material_analysis"   class="diagnose_item_content"></div>
                                </div>
                            <div class="line"></div>
                            <p  class="diagnose_type_title">不准确的要点为：</p>
                                <div v-show="item.question_correct.answer_diagnose.inaccurate_point.length==0">无</div>
                                <div v-show="item.question_correct.answer_diagnose.inaccurate_point.length!=0" v-for="diagnose_inaccurate_item in item.question_correct.answer_diagnose.inaccurate_point">
                                    <div class="diagnose_type_title">
                                        <span v-html="diagnose_inaccurate_item.user_answer"></span><span v-html='diagnose_inaccurate_item.user_score'></span>
                                    </div>
                                    <div>
                                        <span v-html="diagnose_inaccurate_item.standard_answer"></span><span v-html='diagnose_inaccurate_item.standard_score'></span>
                                    </div>
                                    <p v-show="diagnose_inaccurate_item.material_content"  class="diagnose_title">对应材料：</p>
                                    <div v-html="diagnose_inaccurate_item.material_content"   class="diagnose_item_content"></div>
                                    <p v-show="diagnose_inaccurate_item.material_analysis"  class="diagnose_title">要点讲解：</p>
                                    <div v-html="diagnose_inaccurate_item.material_analysis"   class="diagnose_item_content"></div>
                                </div>
                        </div>
                    </div>
                    <!-- 优点 -->
                    <div class="item-answer clearfix" v-if="item.score_mode==0">
                        <div class="answer-title">优点
                            <div v-show="item.question_correct.answer_merit.length!=0"  @click="openClose(index,'is_merit')">
                                <span class="open-close" v-show="item.is_merit">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_merit">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                        </div>
                        <div v-show="is_click"></div>
                        <div v-show="item.question_correct.answer_merit.length!=0 && item.is_merit">
                            <div v-for="answer_merit_item in item.question_correct.answer_merit">
                                <div class="advantage-title">{{ answer_merit_item.part_name }}：</div>
                                <div class="advantage-info" v-html="answer_merit_item.list"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 问题 -->
                    <div class="item-answer clearfix" v-if="item.score_mode==0">
                        <div class="answer-title">问题
                            <div v-show="item.question_correct.answer_defect.length!=0"  @click="openClose(index,'is_defect')">
                                <span class="open-close" v-show="item.is_defect">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_defect">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                        </div>
                        <div v-show="item.question_correct.answer_defect.length!=0 && item.is_defect">
                            <div v-for="answer_defect_item in item.question_correct.answer_defect">
                                <div class="advantage-title">{{ answer_defect_item.part_name }}：</div>
                                <div class="advantage-info" v-html="answer_defect_item.list"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 建议 -->
                    <div class="item-answer clearfix" v-if="item.score_mode==0">
                        <div class="answer-title">建议
                            <div v-show="item.question_correct.answer_advance"   @click="openClose(index,'is_advance')">
                                <span class="open-close" v-show="item.is_advance">收起 <span class="el-icon-arrow-up"></span></span>
                                <span class="open-close" v-show="!item.is_advance">展开 <span class="el-icon-arrow-down"></span></span>
                            </div>
                        </div>
                        <div class="advantage-info" v-show="item.question_correct.answer_advance && item.is_advance" v-html="item.question_correct.answer_advance">
                        </div>
                    </div>

                </div>
                <!-- 参考答案 -->
                <div class="stem">
                    <div class="item-title">参考答案</div>
                    <div class="item-content" v-html="item.question_correct.question_correct_answer">
                    </div>
                </div>
                <!-- 答案解析 -->
                <div class="stem">
                    <div class="item-title">答案解析</div>
                    <div class="item-content" v-html="item.question_correct.question_explain">
                    </div>
                </div>
                <div class="teacher-comment">
                    <div class="comment-container">
                        <el-col :span="18">
                            <el-button
                            type="primary"
                            plain
                            size="middle"
                            :disabled="String(item.comment_mode).split(',').includes('0')"
                            @click="goPage(`/paper-assess/${record_id}/${$route.params.user_id}/${$route.params.sso_id}/${$route.params.iip_paper_id}/${$route.params.tiku_paper_id}/${item.question_id}/${item.has_score_standard ? item.question_correct.question_score :item.question_correct.score}/${item.score_mode}/${item.need_score}/${(item.question_answer_sheet_arr && item.question_answer_sheet_arr.length) || 0}/${item.comment_mode}/${papername}/${item.question_num}`)"
                            >
                              {{is_publish ? '查看点评' : '教师点评'}}
                            </el-button>
                        </el-col>
                    </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            </div>

        </div>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
    import VideoPlayer from '@/components/video-player'
    import global_ from "../../global/index"

    export default {
        components: {
            VideoPlayer
        },
        data() {
            return {
                action_type: 0,
                questionTab: 0,
                activeName: 'first',
                activeName2: 'first_1',
                dialogVisible: false,
                dialogImageUrl: '',
                is_click:false,
                is_publish:false,
                papername:'',
                paper_score:'',
                user_score: '',
                objective_score: '',
                question_list:"",
                question_id_list: null,
                question_img_list: null,
                record_id: null,
            };
        },
        methods:{
            handleClick () {
              this.$nextTick(() => {
                this.$refs.box[this.questionTab].scrollTop = this.$refs[this.activeName][this.questionTab].offsetTop;
              })
            },
            handleClick2 () {
              this.$nextTick(() => {
                this.$refs.box2[this.questionTab].scrollTop = this.$refs[this.activeName2][this.questionTab].offsetTop;
              })
            },
            handlePictureCardPreview (imgUrl) {
              this.dialogImageUrl = imgUrl;
              this.dialogVisible = true;
            },
            handleDownload(file) {
              console.log('下载图片');
              var x = new XMLHttpRequest();
              x.open("GET", file.url, true);
              x.responseType = 'blob';
              x.onload=function(e){
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = file.name || "photo";
                  a.click();
              }
              x.send();
            },
            // 跳转页面
            goPage (router) {
              const view = this.$router.resolve({
                  path:router
              })
              window.open(view.href, '_blank')
            },
            getInfo() {
                this.$api.GETUSERANSWERINFO({
                    record_id: this.$route.params.record_id,
                    iip_paper_id: this.$route.params.iip_paper_id,
                    tiku_paper_id: this.$route.params.tiku_paper_id,
                }).then((res) => {
                    if(res.retcode == 0){
                        console.log(res);
                        // return;
                        // this.is_publish = res.data.paper_status == 0 ? false:true
                        // this.papername = res.data.paper_name;
                        // this.paper_score = res.data.paper_score;
                        // this.user_score = res.data.user_score;
                        this.question_list = res.data.map((v,i) => {
                            v.is_evaluate = true;
                            v.is_merit = true;
                            v.is_defect = true;
                            v.is_advance = true;
                            // v.is_different = true;
                            v.is_diagnose = true;
                            v.question_num = '问题'+ this.toChies(i);
                            v.question_answer_sheet_arr = [];
                            if (v.question_answer_sheet) {
                              v.question_answer_sheet_arr.push({
                                name: v.question_answer_sheet,
                                url: v.question_answer_sheet
                              })
                            }
                            if (v.question_correct.user_answer_video && v.question_correct.user_answer_video.indexOf('http:') > -1) {
                                v.question_correct.user_answer_video = v.question_correct.user_answer_video.replace('http:', 'https:');
                            }
                            if (v.question_correct.answer_video && v.question_correct.answer_video.indexOf('http:') > -1) {
                                v.question_correct.answer_video = v.question_correct.answer_video.replace('http:', 'https:');
                            }
                            // 本地调试
                            // v.question_correct.user_answer_video = 'https://gcik47gyt746q6nqdze.exp.bcevod.com/mda-kebj53g2anrmjsza/mda-kebj53g2anrmjsza.m3u8';
                            // v.question_correct.question_pic = [
                            //   'https://s.eoffcn.com/pigai/answersheet/20200512/1589253736-21658-134771.jpg',
                            //   'https://s.eoffcn.com/pigai/answersheet/20200512/1589253736-21658-134771.jpg',
                            //   'https://s.eoffcn.com/pigai/answersheet/20200512/1589253736-21658-134771.jpg',
                            //   'https://s.eoffcn.com/pigai/answersheet/20200512/1589253736-21658-134771.jpg',
                            //   'https://s.eoffcn.com/pigai/answersheet/20200512/1589253736-21658-134771.jpg'
                            // ];
                            // v.has_score_standard = 0;
                            if (!v.has_score_standard) {
                                return v;
                            }
                            v.content_standard = v.question_correct.content_standard.map(function(h,j) {
                                // h.user_answer  表示用户文字作答
                                const word = h.user_answer;
                                const word_arr = [];
                                let str = "";
                                h.section.map(function(a,b) {
                                        if(a.text && a.position){
                                            word_arr.push(a.position.split(",")[0],a.position.split(",")[1])

                                        }

                                    h.word_arr = word_arr
                                    a.is_error = true;
                                    a.error_tip = "";
                                    return a;
                                })
                                if(word_arr.length==0){
                                     str = h.user_answer;
                                }else{
                                    for(var n=0;n<word_arr.length/2;n++){
                                        const red = h.section[n].score< h.section[n].max_score?'red':'';
                                        if(n==0){
                                            str += h.user_answer.substring(0,word_arr[n]) + "<span class='info_border "+ red +"'>" + h.user_answer.substring(word_arr[n],word_arr[n+1]-1) +"<span class='tag "+ red +"'  attr-score='"+ h.section[n].score+"分'>"+ h.user_answer.substring(word_arr[n+1]-1,word_arr[n+1]) +"</span></span>"
                                        }else{
                                            str += h.user_answer.substring(word_arr[2*n-1],word_arr[2*n]) + "<span class='info_border "+ red +"' >" + h.user_answer.substring(word_arr[2*n],word_arr[2*n+1]-1) +"<span class='tag "+ red +"' attr-score='"+ h.section[n].score+"分'>"+ h.user_answer.substring(word_arr[2*n+1]-1,word_arr[2*n+1]) +"</span></span>"

                                        }

                                    }
                                }

                                if(word_arr[word_arr.length-1]<h.user_answer.length){
                                    str += h.user_answer.substring(word_arr[word_arr.length-1],h.user_answer.length)
                                }
                                h.str = str;
                                return h;
                            })
                            v.structure_standard = v.question_correct.structure_standard.map(function(h,j) {
                                h.is_error = true;
                                h.error_tip = "";
                                return h;
                            })
                            return v;
                        });
                        console.log(this.question_list);

                    }else{
                        this.$message.error(res.message);
                    }


                })
            },
            viewMetrail:function(item) {
                const view = this.$router.resolve({
                    path:'/view-paper-material/'+ item.question_id + '/' + this.$route.params.tiku_paper_id + '/' + this.$route.params.record_id + '/' + this.papername + '/' + item.question_num
                })
                window.open(view.href, '_blank')
            },
            toChies:function(num){
                    const upperNumbers= [ '一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '百', '千', '万', '亿']
                    const length = String(num).length
                    if (length === 1) {
                      return upperNumbers[num]
                    } else if (length === 2) {
                      if (num === 9) {
                        return upperNumbers[num]
                      } else if (num > 9 && num < 19) {
                        const index = String(num)
                        return '十' + upperNumbers[index.charAt(1)]
                      } else {
                        const index = String(num)
                        if(index.charAt(1)==9){
                            return upperNumbers[index.charAt(0)] + '十'
                        }else{
                            return upperNumbers[index.charAt(0)-1] + '十' + upperNumbers[index.charAt(1)]
                        }

                      }
                    } else {
                      return ''
                    }
            },
            openClose:function(i,type){
                this.is_click = !this.is_click;
                this.question_list[i][type] = !this.question_list[i][type];
                // this.question_list[i][type] = false;
            },
            publish:function(){
                this.$api.PUBLISHCORRECTRESULT({
                  objective_score: this.objective_score,
                  total_score: this.paper_score,
                  user_record_id: this.record_id
                }).then(res => {
                  console.log('发布给学员结果：', res);
                  if (res.retcode == 0) {
                    var bc = new BroadcastChannel('paper_list');
                    bc.postMessage('pageRefresh');
                    this.$message({
                      message: '发布成功',
                      type: 'success',
                      onClose: () => {
                        window.close();
                      }
                    });
                  } else if (res.retcode == 10009) {
                    let setTeacherRemark_item;
                    let noTeacherRemark = [];
                    this.question_list.forEach((item, index) => {
                        if (item.question_id == res.data[0]) {
                          setTeacherRemark_item = item;
                        }
                        if(res.data.includes(Number(item.question_id))){
                            noTeacherRemark.push(index + 1);
                        }
                    })
                    if (!setTeacherRemark_item || !noTeacherRemark.length) {
                      this.$message.error('前端错误-没有获取到未点评试题信息');
                      return;
                    }
                    this.$confirm('<p style="color:#bbb;"><span style="color:red;">第'+ noTeacherRemark.join("、") +'题</span>没有点评完成，只有点评完成之后，才能发布给学员</p>', '发布失败', {
                      confirmButtonText: '去点评',
                      cancelButtonText: '取消',
                      type: 'error',
                      showClose:false,
                      closeOnClickModal:false,
                      dangerouslyUseHTMLString:true,
                    }).then(() => {
                        // setTeacherRemark_item = this.question_list[0];
                        this.goPage(`/paper-assess/${this.record_id}/${this.$route.params.user_id}/${this.$route.params.sso_id}/${this.$route.params.iip_paper_id}/${this.$route.params.tiku_paper_id}/${setTeacherRemark_item.question_id}/${setTeacherRemark_item.has_score_standard ? setTeacherRemark_item.question_correct.question_score :setTeacherRemark_item.question_correct.score}/${setTeacherRemark_item.score_mode}/${setTeacherRemark_item.need_score}/${(setTeacherRemark_item.question_answer_sheet_arr && setTeacherRemark_item.question_answer_sheet_arr.length) || 0}/${setTeacherRemark_item.comment_mode}/${this.papername}/${setTeacherRemark_item.question_num}`)
                    }).catch(() => {
                    });
                  }else if (res.retcode == 10008) {
                    this.$message.error(`试卷的批改总分(${res.data})超过了试卷的设置的总分`)
                  } else {
                    this.$message.error(res.message);
                  }
                })
            },
            tabClick:function(tab) {
              // console.log('大导航：', tab);
                this.$nextTick(() => {
                    this.questionTab = tab.index;
                    this.activeName = 'first';
                    this.activeName2 = 'first_1';
                    if (this.$refs.box && this.$refs.box[this.questionTab]) this.$refs.box[this.questionTab].scrollTop = 0;
                    if (this.$refs.box2 && this.$refs.box2[this.questionTab]) this.$refs.box2[this.questionTab].scrollTop = 0;
                    document.querySelector('.el-tabs__content').scrollTop = '0'
                })

            }
        },
        created () {
            this.action_type = this.$route.params.status;
            this.is_publish = this.action_type == 1;
            this.record_id = this.$route.params.record_id;
            // this.papername = window.localStorage.getItem(`exercise_name${this.$route.params.record_id}`);
            // this.paper_score = window.localStorage.getItem(`paper_total_score${this.$route.params.record_id}`);
            // this.user_score = window.localStorage.getItem(`paper_user_score${this.$route.params.record_id}`);
            // this.objective_score = window.localStorage.getItem(`paper_objective_score${this.$route.params.record_id}`);
            this.papername = this.$route.params.exercise_name;
            this.paper_score = this.$route.params.total_score;
            this.user_score = this.$route.params.score;
            this.objective_score = this.$route.params.objective_score;
            this.getInfo()
            var bc = new BroadcastChannel('paper_channel');
            var _this = this;
            bc.onmessage = function (ev) {
              // console.log('------------', ev);
              if (_this.question_list.length) {
                _this.question_list = _this.question_list.map(item => {
                  if (item.question_id == ev.data) {
                    item.is_man_made_correct = 1;
                  }
                  return item;
                })
              }
            }
        }
    }
</script>

<style lang="less">
    .status_image{
        width: 15px;
        height: 15px;
        vertical-align: middle;
    }
    .diagnose_content{
       font-size: 14px;
       margin-bottom: 20px;
    }
    .diagnose_type_title{
        line-height: 47px;
    }
    .diagnose_title{
        padding-left: 16px;
        margin:0;
        line-height: 47px;
    }
    .diagnose_item_content{
        padding-left: 30px;
        line-height: 47px;
    }
    .diagnose_item_content p{
        margin:0;
    }
    .line{
        width: 100%;
        height: 1px;
        background: #ccc;
    }
    .paper-info-page .content .el-upload.el-upload--picture-card {
      display: none;
    }
</style>
<style>
    .left{
        float: left;
    }
    .half{
        width: 50%;
        min-height: 1px;
    }
    .paper-info-page .el-input--suffix span.el-input__suffix{
        display: none !important;
    }
    .paper-info-page .user-answer-content{
        margin-bottom: 20px;
    }
    .paper-info-page .item-title{
        font-size: 16px;
        line-height: 44px;
        font-weight: bolder;
    }
    .paper-info-page .item-content{
        font-size: 14px;
        /* padding-left: 16px; */
    }
    .paper-info-page .item-content p{
        margin:inherit !important;
        line-height: 26px;
    }
    .paper-info-page .time-info{
        font-size: 16px;
    }
    .paper-info-page .time-info .score{
        margin-left: 200px;
    }
    .paper-info-page .answer-title{
        font-size: 14px;
        line-height: 66px;
        padding-left: 10px;
        box-sizing: border-box;
        position: relative;
    }
    .paper-info-page .answer-title .open-close{
        position: absolute;
        right:0;
        top:0;
        color: #aaa;
        cursor: pointer;
    }
    .paper-info-page .answer-title::before{
        content: "";
        position: absolute;
        left:0;
        top:25px;
        height: 15px;
        width: 3px;
        background-color: #1890ff;
    }
    .paper-info-page{
        width: 100%;
        padding: 0 30px;
        height: 100%;
        min-height: 500px;
    }

    .paper-info-page .operate-btn{
        float: right;
    }
    .paper-info-page .content{
        padding-top: 100px;
        padding-bottom: 60px;
        box-sizing: border-box;
        height: 100%;
    }
    .paper-info-page .content-container{
        height: 100%;
    }
    .paper-info-page .page-tab.el-tabs{
        padding-top: 40px;
        padding-bottom: 10px;
        box-sizing: border-box;
        height: 100%;
    }

    .paper-info-page .page-tab>.el-tabs__header{
        position: fixed;

    }
    .paper-info-page .page-tab>.el-tabs__content{
        height: 100%;
        box-sizing: border-box;
        padding-top: 40px;
        overflow: auto;

    }
    .paper-info-page .page-tab.el-tabs--border-card{
        background: inherit;
        border: none;
        box-shadow: none;
    }
    .paper-info-page .teacher-comment{
        height: 60px;
        width: 100%;
        padding: 0 0px;
        box-sizing: border-box;
        position: fixed;
        bottom:0;
        left:0;
        z-index: 9;

    }
    .paper-info-page .comment-container{
        box-sizing: border-box;
        padding: 12px 30px;
        background-color: #fff;
        height: 100%;
        width: 100%;
    }
    .paper-info-page .answer-content-item{
        font-size: 14px;
        margin-top: 25px;
    }
    .paper-info-page .score-point .box-card{
        margin-top: 14px;
    }
    .paper-info-page .score-point .el-input{
        width: 45%;
    }
    .paper-info-page .score-point .el-row{
        line-height: 40px;
    }

    .paper-info-page .score-point .key-item{
        margin-top: 10px;
        line-height: 20px;
    }
    .paper-info-page .score-point .key-item .key-line .choose,.paper-info-page .score-point .key-item .key-line.choose{
        color: #1890ff;
    }
    .paper-info-page .answer-left{
        text-indent: 2em;
        padding-right: 35px;
        line-height: 38px;
        box-sizing: border-box;
    }
    .paper-info-page .image-useranswer .answer-left{
        text-indent: inherit;
    }
    .paper-info-page .answer-left .image{
        width:45%;
        margin-right: 2%;
        height: 136px;
    }
    .paper-info-page .answer-right .answer-type{
        line-height: 38px;
        /*text-align: center;*/
    }
    .paper-info-page .answer-right .answer-type {
        /*margin-top: 25px;*/
        margin-bottom: 20px;
    }
/*    .paper-info-page .answer-right .answer-type:nth-child(1){
        margin-top: 0px;
    }*/
    .paper-info-page .structure-standard div:nth-child(1) .answer-type{
        margin-top: 0px;
    }
    .paper-info-page .structure-standard .answer-type{
        margin-top: 25px;
    }
/*    .paper-info-page .structure-standard .answer-type:nth-child(1){
        margin-top: 0px !important;
    }*/
    .paper-info-page .answer-right .answer-type .image{
        vertical-align: middle;
        margin-right: 10px;
    }
    .paper-info-page .item-answer .des-info{
        font-size: 14px;
        text-indent: 2em;
    }
    .paper-info-page .student-score.red{
        color: red;
    }
    .paper-info-page .font-s{
        font-size: 16px;
    }
    .paper-info-page .correction-score{
        position: relative;
    }
    .paper-info-page .score-error{
        color: red;
        font-size: 12px;
        position: absolute;
        top:30px;
        left:83px;
    }
    .paper-info-page .advantage-title{
        font-size: 14px;
        line-height: 42px;
        padding-left: 10px;
    }
    .paper-info-page .advantage-info{
        font-size: 14px;
        padding-left: 34px;
    }
    .paper-info-page .score-point .el-card__body{
        padding:10px;
    }
    .paper-info-page .page-tab.el-tabs--border-card>.el-tabs__header{
        border-bottom: none;
    }
    .paper-info-page .page-tab > .el-tabs__header{
        position: fixed;
        left:0;
        top:100px;
        z-index: 10;
        width: 100%;
        padding:0 30px;
        box-sizing: border-box;
        border:none;
    }
    .paper-info-page .page-tab > .el-tabs__header > .el-tabs__nav-wrap{
        min-width: 1280px;
        overflow:auto;
        border-top: 1px solid #dcdfe6;
        border-bottom: 1px solid #dcdfe6;
    }
    .paper-info-page .page-tab > .el-tabs__header > .el-tabs__nav-wra > .el-tabs__nav{
        min-width: 1280px;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
    .paper-info-page .page-tab > .el-tabs__content{
        height: 100%;
        box-sizing: border-box;
        overflow: auto;
        /*min-height: 600px;*/
    }
    .paper-info-page .info_span{
        text-decoration: underline;
    }
    .paper-info-page .info{
        line-height: 40px;
    }
    .paper-info-page .info_border{
        /*position: relative;*/
        border-bottom: 1px #1890ff dashed;
    }
    .paper-info-page .info_border.red{
        /*position: relative;*/
        border-bottom: 1px #f24a78 dashed;
    }
/*    .paper-info-page .info_border .score-point{
        position: absolute;
        right:0;
        width:50px !important;
        display: inline-block;
        bottom:-26px;
        font-size:12px;
    }*/
    .paper-info-page .info_border .tag{
        position: relative;
        /*border-bottom: 1px red dashed;*/
    }
    .paper-info-page .info_border .tag.red:after{
        color: #f24a78;
    }
    .paper-info-page .info_border .tag:after{
        content: attr(attr-score);
        position: absolute;
        width: 61px;
        line-height: 12px;
        top: 100%;
        left: -30px;
        color: #1890ff;
        font-size: 12px;
    }
   .clearfix:after {visibility: hidden;display: block;font-size: 0;content: " ";clear: both;height: 0;}
   .clearfix{*zoom:1;}
</style>
<style lang="less">
.paper-info-page {
  .blue{
      color: #1890ff;
      cursor: pointer;
  }
  .title {
    height: 100px;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    position: fixed;
    top:0;
    left:0;
    background-color: rgba(244, 248, 249, 1);
    z-index: 99;
    display: flex;
    .title-left {
      flex: 1 0 auto;
      height: 100%;
      .row-1 {
        height: 70px;
        line-height: 100px;
        font-weight: bolder;
      }
      .score {
        height: 30px;
        line-height: 30px;
        span {
          font-weight: bolder;
        }
      }
    }
    .title-right {
        flex: 0 0 auto;
        height: 100%;
        line-height: 100px;
    }
  }
  .content {
    .part {
      &.part-flex {
        display: flex;
        .item-content {
          max-height: 400px;
          overflow-y: scroll;
          overflow-x: hidden;
          word-break: break-all;
        }
      }
      .item-title {
        font-weight: bolder;
      }
      .item-content {
        font-size: 14px;
        line-height: 25px;
        padding: 0;
        // p {
        //     margin: none !important;
        //     margin: inherit !important;
        //     line-height: 26px;
        // }
        .part-1 {
          .part-title {
            &::before {
                content: "";
                position: absolute;
                left: 0;
                top: 4px;
                height: 17px;
                width: 3px;
                background-color: #1890ff;
            }
            font-size: 14px;
            font-weight: bolder;
            position: relative;
            height: 25px;
            padding-left: 5px;
            margin: 10px 0;
          }
          .part-content {
            .all-words {
              margin-top: 25px;
            }
            >.image{
                width:45%;
                margin-right: 2%;
                height: 136px;
            }
            .answer-type .image {
                vertical-align: middle;
                margin-right: 10px;
            }
          }
        }
      }
      .left {
        flex: 50%;
      }
      .right {
        flex: 50%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/paper-info/index.vue